export default "__VITE_ASSET__23e956ee__"